import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreatePudoTransaction, ExtendedPudoTransaction, ExtendedPudoTransactionListResponse, ExtendedPudoTransactionQueryParams } from '@frontend/transaction/types';

export class TransactionPuDoClient extends APIClient {
    public static readonly endpoint = '/transaction-api/';

    public static async postPudoTransaction(account_id: string, body: CreatePudoTransaction): Promise<ExtendedPudoTransaction> {
        const response = await this.post(`${this.endpoint}/v1/accounts/${account_id}/pudo-transactions`, body);
        return await this.handleResponse<ExtendedPudoTransaction>(response);
    }

    public static async fetchPudoTransactions(queryParams?: ApiQueryParams<ExtendedPudoTransactionQueryParams>): Promise<ExtendedPudoTransactionListResponse> {
        return await this.apiPaginated<ExtendedPudoTransactionListResponse, ExtendedPudoTransactionQueryParams>(
            `${this.endpoint}/ext/v1/pudo-transactions`,
            queryParams
        );
    }

    public static async fetchPudoTransaction(
        accountId: string,
        transactionId: string,
        queryParams?: ApiQueryParams<ExtendedPudoTransactionQueryParams>
    ): Promise<ExtendedPudoTransaction> {
        return await this.apiPaginated<ExtendedPudoTransaction, ExtendedPudoTransactionQueryParams>(
            `${this.endpoint}/ext/v1/accounts/${accountId}/pudo-transactions/${transactionId}`,
            queryParams
        );
    }
}
